import React, {FC} from "react"
import {H4} from "@irati/ui/src/Typography"
import ValidationButton from "@irati/ui/src/FormItem/ValidationButton"
import {Address} from "@irati/types"
import Flex from "@irati/ui/src/Flex"
import {FormattedMessage} from "@irati/utils/lang"
import FirstName from "./FirstName"
import LastName from "./LastName"
import AddressOne from "./AddressOne"
import AddressTwo from "./AddressTwo"
import City from "./City"
import Postcode from "./Postcode"
import Region from "./Region"
import AddressFormContext from "../../../utils/addressFormContext"
import {ResponsiveFlex, CityWrapperMobile, CityWrapperDesktop, CustomFlex} from "./styled"

interface Props {
  onFieldChange: (newAddress: Address) => void,
  onClick: () => void,
  load: Promise<any> | undefined,
  shippingAddress: Address
}

const Form: FC<Props> = ({onFieldChange, load, shippingAddress, onClick}) => {
  return (
    <AddressFormContext.Provider value={{shippingAddress, onFieldChange}}>
      <Flex direction="column" justifyContent="flex-start" marginBottom={3}>
        <H4 paddingLeft={2} marginBottom={2}>
          <FormattedMessage id="flexiRewards.merchandise.checkout.deliveryAddress" />
        </H4>
        <ResponsiveFlex>
          <FirstName />
          <LastName />
        </ResponsiveFlex>
        <AddressOne />
        <AddressTwo />
        <CityWrapperMobile>
          <City />
        </CityWrapperMobile>
        <ResponsiveFlex>
          <CityWrapperDesktop>
            <City />
          </CityWrapperDesktop>
          <Postcode />
          <Region />
        </ResponsiveFlex>

        <CustomFlex marginLeft={1}>
          <ValidationButton primary onClick={onClick} load={load} full>
            <FormattedMessage id="flexiRewards.merchandise.checkout.form.continue" />
          </ValidationButton>
        </CustomFlex>
      </Flex>
    </AddressFormContext.Provider>
  )
}

export default Form
